module.exports = __webpack_public_path__ + "img/cave142.42aa073c.jpg";